export default function ChatGPTIcon6(
  props: Pick<React.SVGProps<SVGSVGElement>, "className">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      className={props.className}
    >
      <path
        d="M15.039 0.718262H11.8554L17.6512 16.3122L20.8349 16.3125L15.039 0.718262ZM5.83883 0.718262L0.0429688 16.3125H3.29172L4.46129 13.0378L10.543 13.0375L11.7254 16.3125H14.9742L9.16554 0.718262H5.83883ZM5.52676 10.1398L7.50222 4.65597L9.49038 10.1398H5.52676Z"
        fill="#1F1F1E"
      />
    </svg>
  );
}
